import type { Messages } from "./en";

export const es: Messages = {
  "nav.home": "Inicio de LEARNABLE",
  "nav.main": "Principal",
  "nav.courses": "Cursos",
  "nav.review": "Repaso",
  "nav.progress": "Progreso",
  "nav.guide": "Guía",
  "nav.marketplace": "Mercado",
  "nav.streak": "Racha diaria: {n}",
  "nav.xp": "Experiencia total: {n} XP",

  "account.menu": "Cuenta",
  "account.settings": "Ajustes",
  "account.guide": "Cómo funciona LEARNABLE",
  "account.signOut": "Cerrar sesión",

  "common.save": "Guardar",
  "common.saved": "Guardado.",
  "common.saving": "Guardando…",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.pleaseWait": "Espera…",

  "signin.title": "Inicia sesión en LEARNABLE",
  "signin.registerTitle": "Crea tu cuenta",
  "signin.email": "Correo electrónico",
  "signin.password": "Contraseña",
  "signin.passwordRule": "Al menos 12 caracteres.",
  "signin.submit": "Iniciar sesión",
  "signin.register": "Crear cuenta",
  "signin.forgot": "¿Olvidaste tu contraseña?",
  "signin.toRegister": "Crear una cuenta",
  "signin.toSignIn": "Ya tengo una cuenta",
  "signin.language": "Idioma",

  "password.current": "Contraseña actual",
  "password.new": "Nueva contraseña (12 caracteres o más)",
  "password.change": "Cambiar contraseña",
  "password.changed": "Contraseña cambiada. Se cerró la sesión en tus otros dispositivos.",

  "settings.title": "Ajustes",
  "settings.intro": "Tu perfil y tus preferencias. Se guardan en tu cuenta y se aplican en todos tus dispositivos.",
  "settings.profile": "Perfil",
  "settings.displayName": "Nombre visible",
  "signin.emailOrUsername": "Correo o nombre de usuario",
  "signin.username": "Nombre de usuario (opcional)",
  "signin.usernameHint": "3–30 letras, dígitos, puntos, guiones o guiones bajos. Puedes iniciar sesión con él en lugar del correo.",
  "settings.username": "Nombre de usuario",
  "settings.usernameHint": "Opcional. Te permite iniciar sesión con este nombre en lugar del correo. Los demás no lo ven. Déjalo vacío para quitarlo.",
  "settings.displayNameHint": "Se muestra en lugar de tu correo. Déjalo vacío para usar tu correo.",
  "settings.email": "Correo electrónico",
  "settings.emailHint": "La dirección con la que inicias sesión.",
  "settings.language": "Idioma",
  "settings.languageHint": "El idioma de los menús y las páginas. El material de tus cursos y los comentarios de la IA siguen en el idioma del curso.",
  "settings.translationNote": "La traducción está en curso: algunas pantallas siguen en inglés.",
  "settings.study": "Estudio",
  "settings.timezone": "Zona horaria",
  "settings.timezoneHint": "Tu día de estudio, tu racha y tu objetivo diario siguen esta zona horaria.",
  "settings.dailyGoal": "Objetivo diario",
  "settings.dailyGoalHint": "Respuestas al día.",
  "settings.security": "Seguridad",
  "settings.signOutHint": "Al cerrar sesión se borran de este navegador los datos de tu cuenta.",

  "guide.title": "Cómo funciona LEARNABLE",
  "guide.intro": "LEARNABLE convierte tu propio material de estudio en preguntas, revisa tus respuestas y programa cada repaso justo antes de que lo olvides.",
  "guide.contents": "Contenido",
  "guide.structure.title": "1. Cómo se organiza un curso",
  "guide.structure.body": "Un curso se divide en capítulos, los capítulos en temas y los temas en conceptos. Cada concepto contiene elementos de aprendizaje: los datos que hay que recordar, cada uno preguntado con una o varias preguntas.",
  "guide.material.title": "2. Añade tu material",
  "guide.material.body": "Abre un curso y sube archivos PDF, Word, PowerPoint, de texto o Markdown, o pega texto. Si ya tienes preguntas y respuestas, súbelas con líneas que empiecen por \"Question:\" y \"Answer:\" (o \"Domanda:\" y \"Risposta:\"): cada una se convierte en un concepto, sin usar IA.",
  "guide.curriculum.title": "3. Crea el temario",
  "guide.curriculum.body": "Pide a la IA que proponga capítulos, temas y conceptos a partir de tu material. Revisa la propuesta, renombra, mueve o elimina lo que quieras y después acéptala. Nada cambia hasta que la aceptas.",
  "guide.study.title": "4. Estudia un concepto",
  "guide.study.body": "Abre un concepto y pulsa Activar: sus elementos de aprendizaje se preparan a partir de tu material. Léelos y pulsa \"He estudiado este concepto\". Cada pregunta se repite hasta que la respondas bien tres veces (no necesariamente seguidas), con comentarios tras cada respuesta.",
  "guide.answer.title": "5. Responde y recibe comentarios",
  "guide.answer.body": "Escribe tu respuesta con tus palabras o pulsa \"Di tu respuesta\" para dictarla. Hay una pista disponible, pero reduce los XP a la mitad. La IA evalúa el significado, no las palabras exactas, y muestra cuatro puntuaciones y una lista de lo correcto, lo que falta y lo erróneo. La respuesta de referencia y sus fuentes están siempre a un clic.",
  "guide.disagree.title": "6. Si no estás de acuerdo",
  "guide.disagree.body": "Pulsa \"Disagree with the grade?\". Puedes explicar por qué y pedir a la IA una segunda opinión (ambas quedan visibles), o calificar tú la respuesta. Tu propia nota siempre prevalece.",
  "guide.review.title": "7. Repasa a tiempo",
  "guide.review.body": "Cada respuesta coloca su pregunta en un calendario: cuanto mejor la sabes, más tarda en volver. La página Repaso y tu panel muestran lo que toca repasar y cuánto tiempo lleva aproximadamente.",
  "guide.progress.title": "8. Sigue tu progreso",
  "guide.progress.body": "Tu racha cuenta los días en que estudiaste, los XP premian las respuestas correctas y el objetivo diario marca tu ritmo. \"Lo que sigues fallando\" reúne los errores encontrados en tus respuestas recientes, con un botón para practicar.",
  "guide.organise.title": "9. Mantén todo ordenado",
  "guide.organise.body": "En \"Gestionar preguntas\" puedes seleccionar preguntas sueltas o capítulos, temas y conceptos enteros para eliminarlos, pausarlos, reanudarlos o moverlos, editar una pregunta y arrastrar ⠿ para reordenar. Las secciones largas se pliegan con la flecha junto a su título.",
  "guide.marketplace.title": "10. Comparte y consigue cursos",
  "guide.marketplace.body": "En el Marketplace encuentras cursos creados por otros usuarios, por categoría, nivel, idioma y tamaño. Antes de añadir uno ves su página: qué trata, para quién es, qué aprenderás, sus capítulos y cuántas preguntas tiene. \"Añadir a mis cursos\" lo pone en tu panel: su autor mantiene las preguntas al día y tú no puedes editarlas, pero tu estudio es tuyo (tu plan, tus respuestas, tus XP y la prioridad que das a cada pregunta). El material del autor no se puede descargar. Para compartir un curso tuyo, ábrelo y escribe su \"Página del marketplace\", guárdala como borrador y luego publícala.",
  "guide.glossary.title": "Palabras que usa la app",
  "guide.term.concept": "Concepto",
  "guide.term.concept.def": "Una idea de tu curso, como una definición o una regla.",
  "guide.term.item": "Elemento de aprendizaje",
  "guide.term.item.def": "Un dato que recordar dentro de un concepto, con sus preguntas y su respuesta esperada.",
  "guide.term.active": "Active (activo)",
  "guide.term.active.def": "El concepto participa en el estudio y los repasos. Los pausados o no estudiados, no.",
  "guide.term.grades": "Otra vez · Difícil · Bien · Fácil",
  "guide.term.grades.def": "Otra vez, difícil, bien, fácil: cuánto sabías la respuesta. Decide cuándo vuelve la pregunta.",
  "guide.term.mastery": "Dominio",
  "guide.term.mastery.def": "Una estimación de cuánto recuerdas un concepto, a partir de tus repasos.",
  "guide.term.xp": "XP y racha",
  "guide.term.xp.def": "Puntos por las respuestas correctas, y el número de días seguidos que has estudiado.",
  "guide.privacy.title": "Tus datos",
  "guide.privacy.body": "Tus cursos, respuestas y progreso solo los ves tú. El dictado lo transcribe tu navegador; solo se guarda el texto.",
  "help.button": "Ayuda: {topic}",
  "help.more": "Más información",
  "help.nextStep": "Lo más útil que puedes hacer ahora. Los repasos pendientes siempre van primero; después, el material nuevo.",
  "help.courses": "Una tarjeta por curso. El botón verde repasa lo pendiente; el azul continúa con algo nuevo.",
  "help.streak": "Días seguidos con al menos una respuesta. Responde una pregunta hoy para mantenerla.",
  "help.xp": "Puntos de experiencia, que ganas con las respuestas correctas. Usar una pista los reduce a la mitad.",
  "help.goal": "Cuántas respuestas quieres dar cada día. Puedes cambiarlo en Ajustes.",
  "help.planner": "Cuántas preguntas vencen en cada momento y cuánto tiempo llevan aproximadamente.",
  "help.coursePlanner": "Solo este curso: cuántas de sus preguntas vencen y cuándo, y cuánto tiempo llevan aproximadamente. El material nuevo necesita al menos tres respuestas buenas por pregunta.",
  "help.activity": "Un cuadrado por día: cuanto más oscuro, más respondiste.",
  "help.concept": "Un concepto es una idea de tu curso. Empieza a estudiarlo para preparar sus preguntas, lee sus elementos de aprendizaje y luego practica.",
  "help.consolidate": "Pulsa el botón cuando hayas leído los elementos de aprendizaje de abajo. Cada pregunta se repite hasta que la respondas bien tres veces, para que se fije.",
  "help.study": "Escribe la respuesta con tus palabras o díctala. La IA evalúa el significado, no las palabras exactas, y muestra lo correcto o lo que falta.",
  "help.questions": "Marca preguntas sueltas o un capítulo, tema o concepto entero y luego elimínalos, páusalos o muévelos. Arrastra ⠿ para cambiar el orden.",
  "help.marketplace": "Cursos creados por otros usuarios. Abre uno para ver qué trata y cuántas preguntas tiene; añádelo para estudiarlo con tu propio plan. Su autor lo mantiene al día.",
  "help.weakSpots": "Errores encontrados en tus últimas respuestas, agrupados por concepto. Practica hasta que desaparezcan de esta lista.",
  "help.material": "Sube archivos PDF, Word, PowerPoint o de texto, o pega texto. LEARNABLE crea a partir de ellos el curso y sus preguntas.",
  "start.title": "Cómo funciona LEARNABLE",
  "start.intro": "Cuatro pasos. Abre cualquiera para verlo en la guía.",
  "start.hide": "Entendido, ocultar",
  "start.reopen": "Mostrar cómo funciona LEARNABLE",
  "start.material.title": "Añade tu material",
  "start.material.body": "Crea un curso y sube tus apuntes, diapositivas o libros, o pega texto.",
  "start.plan.title": "Aprueba el plan",
  "start.plan.body": "La IA propone capítulos y conceptos. Cambia lo que quieras y acéptalo.",
  "start.study.title": "Estudia y responde",
  "start.study.body": "Lee un concepto y responde a sus preguntas con tus palabras o por voz.",
  "start.review.title": "Repasa a tiempo",
  "start.review.body": "Las preguntas vuelven justo antes de que las olvides. Sigue el botón verde.",
  "nav.community": "Comunidad",
  "community.title": "Comunidad",
  "community.intro": "Mira quién gana más experiencia, sigue a otros estudiantes y anímalos.",
  "community.tab.leaderboard": "Clasificación",
  "community.tab.friends": "Amigos",
  "community.period": "Periodo",
  "community.scope": "Quién",
  "community.period.day": "Hoy",
  "community.period.week": "Esta semana",
  "community.period.month": "Este mes",
  "community.period.all": "Histórico",
  "community.scope.everyone": "Todos",
  "community.scope.friends": "Amigos",
  "community.leader": "Líder",
  "community.xp": "{n} XP",
  "community.you": "Tú",
  "community.yourPlace": "Tu puesto",
  "community.empty": "Nadie ha ganado XP en este periodo todavía.",
  "community.emptyFriends": "Sigue a otros estudiantes para compararte con ellos aquí.",
  "community.windowNote": "Los días siguen la hora UTC; las semanas empiezan el lunes. Solo aparecen quienes se unieron a la comunidad.",
  "community.joinTitle": "Únete a la comunidad",
  "community.joinText": "Todavía no estás en la clasificación. Activa la visibilidad en la comunidad para aparecer, que te encuentren y te sigan. Los demás solo ven tu nombre visible y tus XP, nunca tu correo.",
  "community.joinButton": "Mostrarme en la comunidad",
  "community.needName": "Primero elige un nombre visible en Ajustes.",
  "community.follow": "Seguir",
  "community.following": "Siguiendo",
  "community.friend": "Amigos",
  "community.followsYou": "Te sigue",
  "community.since": "Aprende aquí desde {date}",
  "community.statXpTotal": "XP totales",
  "community.statXpWeek": "XP esta semana",
  "community.statStreak": "Racha de días",
  "community.statFollowers": "Seguidores",
  "community.statFollowing": "Siguiendo",
  "community.followingList": "Personas que sigues",
  "community.followersList": "Tus seguidores",
  "community.searchLabel": "Busca estudiantes por nombre",
  "community.searchPlaceholder": "Buscar por nombre visible",
  "community.search": "Buscar",
  "community.noResults": "No se encontró a nadie. Solo se puede encontrar a quienes se unieron a la comunidad.",
  "community.noFollowing": "Todavía no sigues a nadie.",
  "community.noFollowers": "Aún no tienes seguidores.",
  "community.streakDays": "Racha de {n} días",
  "community.xpToday": "{n} XP hoy",
  "community.notFound": "Este perfil no está disponible.",
  "community.seeLeaderboard": "Ver la clasificación de la comunidad",
  "course.leaderboardLink": "Clasificación del curso",
  "course.leaderboardTitle": "Clasificación del curso",
  "course.leaderboardIntro": "XP ganados en este curso por todos los que lo tienen.",
  "course.leaderboardPrivate": "Este es un curso privado, así que solo tú estás en su clasificación. Los cursos del Marketplace se comparten con todos los que los tienen.",
  "course.leaderboardParticipants": "{n} estudiantes comparten este curso.",
  "settings.community": "Comunidad",
  "settings.communityToggle": "Mostrarme en la comunidad (clasificaciones, búsqueda y seguidores)",
  "settings.communityHint": "Desactivado por defecto. Los demás solo ven tu nombre visible, tus XP y tu racha, nunca tu correo, tus cursos ni tus respuestas. Necesitas un nombre visible para activarlo.",
  "study.repeat.badge": "Casi: repítela",
  "study.repeat.title": "Repasa la respuesta de referencia y luego repítela",
  "study.repeat.body": "Tu respuesta fue sólida en la mayoría de los puntos. Lee la respuesta de referencia de arriba y vuelve a escribirla con tus palabras. Si la repites bien, cuenta como correcta y tu plan avanza. Si no, el elemento vuelve al nivel cero.",
  "study.repeat.label": "Tu respuesta, otra vez",
  "study.repeat.submit": "Repetir",
  "study.repeat.selfGrade": "Calificarla tú en su lugar",
  "study.repeat.evalTitle": "Cómo la repetiste",
  "error.generic": "Algo salió mal. Inténtalo de nuevo.",
  "error.transport": "No se puede conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.",
  "error.session": "Tu sesión ha caducado. Inicia sesión de nuevo.",
  "error.validation": "Parte de la información introducida no es válida.",
  "error.notFound": "Este elemento ya no existe.",
  "error.tooLarge": "Este archivo es demasiado grande.",
  "error.unsupported": "Este tipo de archivo no es compatible. Usa archivos PDF, Word, PowerPoint, de texto o Markdown.",
  "error.aiNotConfigured": "La IA aún no está configurada en el servidor.",
  "error.aiUnavailable": "La IA no está disponible temporalmente. Inténtalo más tarde.",
  "error.aiInvalid": "La IA dio una respuesta inutilizable. Inténtalo de nuevo.",
  "error.state": "Esa acción no es posible en el estado actual.",
  "error.server": "Algo salió mal en el servidor. Inténtalo de nuevo.",
  "error.rateLimited": "Demasiados intentos. Espera un poco e inténtalo de nuevo.",
  "error.managedCourse": "Este curso viene del Marketplace: su autor lo mantiene al día, así que su contenido no se puede cambiar aquí.",
  "studyState.NOT_STUDIED": "Sin estudiar",
  "studyState.STUDIED": "Estudiado",
  "studyState.ACTIVE": "Activo",
  "studyState.PAUSED": "En pausa",
  "studyState.COMPLETED": "Completado",
  "memoryState.NEW": "Nueva",
  "memoryState.LEARNING": "Aprendiendo",
  "memoryState.REVIEW": "En repaso",
  "memoryState.RELEARNING": "Reaprendiendo",
  "memoryState.MASTERED": "Dominada",
  "outcome.AGAIN": "Otra vez",
  "outcome.HARD": "Difícil",
  "outcome.GOOD": "Bien",
  "outcome.EASY": "Fácil",
  "outcomeHelp.AGAIN": "No lo sabía",
  "outcomeHelp.HARD": "Lo sabía, con dificultad",
  "outcomeHelp.GOOD": "Lo sabía",
  "outcomeHelp.EASY": "Lo sabía con facilidad",
  "classification.CORRECT": "Correcta",
  "classification.PARTIALLY_CORRECT": "Parcialmente correcta",
  "classification.MISCONCEPTION": "Concepto erróneo",
  "classification.WRONG": "Incorrecta",
  "classification.UNCERTAIN": "Incierta",
  "role.CORE_TRAINABLE": "Principal",
  "role.SUPPORTING_TRAINABLE": "De apoyo",
  "role.COMMON_TRAP": "Trampa común",
  "role.INFORMATIONAL": "Informativa",
  "role.REFERENCE": "Referencia",
  "role.OPTIONAL_EXTENSION": "Opcional",
  "priority.1": "Esencial",
  "priority.2": "Importante",
  "priority.3": "Extra",
  "label.page": "Página {n}",
  "label.pages": "Páginas {a}–{b}",
  "label.pageShort": "p. {n}",
  "label.pagesShort": "pp. {a}–{b}",
  "category.law": "Derecho",
  "category.economics_business": "Economía y empresa",
  "category.accounting_finance": "Contabilidad y finanzas",
  "category.medicine_health": "Medicina y salud",
  "category.sciences": "Ciencias",
  "category.mathematics": "Matemáticas",
  "category.engineering": "Ingeniería",
  "category.computer_science": "Informática",
  "category.languages": "Idiomas",
  "category.humanities": "Historia y humanidades",
  "category.arts": "Arte y música",
  "category.professional_exams": "Exámenes profesionales",
  "category.other": "Otro",
  "level.all": "Todos los niveles",
  "level.beginner": "Principiante",
  "level.intermediate": "Intermedio",
  "level.advanced": "Avanzado",
  "size.small": "Corto (menos de 50 preguntas)",
  "size.medium": "Medio (50–299 preguntas)",
  "size.large": "Grande (300+ preguntas)",
  "sort.popular": "Más elegidos",
  "sort.newest": "Más recientes",
  "sort.largest": "Más preguntas",
  "lang.it": "Italiano",
  "lang.en": "Inglés",
  "price.free": "Gratis",
  "common.loading": "Cargando…",
  "common.tryAgain": "Reintentar",
  "common.dismiss": "Descartar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.rename": "Renombrar",
  "common.title": "Título",
  "common.description": "Descripción",
  "common.continue": "Continuar",
  "common.search": "Buscar",
  "common.add": "Añadir",
  "common.remove": "Quitar",
  "common.yes": "Sí",
  "common.no": "No",
  "common.collapse": "Contraer {label}",
  "common.expand": "Expandir {label}",
  "drag.item": "Elemento",
  "drag.reorder": "Reordenar {label}",
  "drag.pickedUp": "Cogido {label}, posición {pos} de {total}.",
  "drag.over": "{label} está ahora en la posición {pos} de {total}.",
  "drag.dropped": "{label} soltado en la posición {pos} de {total}.",
  "drag.droppedPlain": "{label} soltado.",
  "drag.cancelled": "Movimiento de {label} cancelado.",
  "drawing.loadFailed": "No se pudo cargar el dibujo.",
  "course.authorOrder": "El autor decide el orden de este curso.",
  "priority.yours": "Tu prioridad",
  "priority.label": "Prioridad",
  "priority.author": "Autor: {name}",
  "priority.useAuthor": "Usar la del autor",
  "editTitle.rename": "Renombrar {label}",
  "label.course": "curso",
  "label.chapter": "capítulo",
  "label.topic": "tema",
  "label.concept": "concepto",
  "library.heading": "Mis cursos",
  "library.count.one": "{n} curso",
  "library.count.other": "{n} cursos",
  "library.shownOf": "{shown} de {total} mostrados",
  "library.search": "Buscar cursos",
  "library.show": "Mostrar",
  "library.sortBy": "Ordenar por",
  "library.new": "+ Nuevo curso",
  "library.marketplace": "🛒 Marketplace",
  "library.empty": "Aún no hay cursos. Crea uno y añade tu material de estudio o tus propias preguntas y respuestas.",
  "library.createFirst": "Crea tu primer curso",
  "library.noMatch": "Ningún curso coincide con esta búsqueda o filtro.",
  "libStatus.all": "Todos los cursos",
  "libStatus.in_progress": "En curso",
  "libStatus.not_started": "Sin empezar",
  "libStatus.due": "Repasos pendientes",
  "libStatus.completed": "Nada nuevo que aprender",
  "libStatus.paused": "En pausa",
  "libStatus.archived": "Archivados",
  "libSort.recent_study": "Estudiados recientemente",
  "libSort.recent_created": "Creados recientemente",
  "libSort.alphabetical": "Alfabético",
  "libSort.most_due": "Más repasos pendientes",
  "card.marketplacePill": "🛒 Del marketplace · de {author}",
  "card.marketplaceHint": "Su autor mantiene el contenido al día; tu estudio es tuyo.",
  "card.continue": "Continuar",
  "card.next": "Siguiente",
  "card.archived": "Archivado",
  "card.paused": "En pausa",
  "card.conceptsStudied": "conceptos estudiados",
  "card.itemsIntroduced": "elementos de estudio presentados",
  "card.moreFor": "Más para {title}",
  "menu.details": "Detalles del curso",
  "menu.material": "Material de estudio",
  "menu.progress": "Progreso",
  "menu.publish": "🛒 Publicar en el marketplace",
  "menu.pause": "Pausar",
  "menu.resume": "Reanudar",
  "menu.archive": "Archivar",
  "menu.restore": "Restaurar",
  "menu.delete": "Eliminar…",
  "menu.confirmOwn": "¿Eliminar \"{title}\"? Sus capítulos, preguntas, material y tus respuestas se eliminan para siempre. Archívalo para conservarlo todo.",
  "menu.confirmMarketplace": "¿Eliminar \"{title}\"? Podrás añadirlo de nuevo desde el Marketplace gratis.",
  "newCourse.aria": "Nuevo curso",
  "newCourse.language": "Idioma del material",
  "newCourse.create": "Crear curso",
  "learn.resume.label": "Reanudar la práctica",
  "learn.resume.hint": "Continúa la ronda que dejaste a medias",
  "learn.study.label": "Aprender el siguiente",
  "learn.study.hint": "Estudia {title}",
  "learn.study.hintNone": "Aprende material nuevo",
  "learn.activate.label": "Empezar a aprender",
  "learn.activate.hint": "Prepara las preguntas de {title} y empieza a estudiarlo",
  "learn.activate.hintNone": "Empieza a estudiar el siguiente concepto",
  "learn.setup.label": "Añadir material",
  "learn.setup.hint": "Añade material de estudio o tus propias preguntas para empezar",
  "learn.none.label": "Todo aprendido ✓",
  "learn.none.hint": "Todo en este curso se ha aprendido",
  "review.none": "✓ Nada que repasar ahora",
  "review.noneTitle": "Nada en este curso necesita repaso ahora",
  "review.aria.one": "Repasar {n} elemento",
  "review.aria.other": "Repasar {n} elementos",
  "review.button": "Repasar",
  "course.practiceHard": "Practica las preguntas difíciles",
  "course.chapters": "Capítulos",
  "course.chaptersEmpty": "Añade un capítulo y luego material de estudio.",
  "course.chapterMeta": "{active} de {total} conceptos activos · dominio {mastery}",
  "course.newChapter": "Título del nuevo capítulo",
  "course.addChapter": "Añadir capítulo",
  "course.curriculum": "Plan de estudios",
  "course.fallback": "Curso",
  "course.allMaterial": "Todo el material de estudio",
  "course.manageQuestions": "Gestionar preguntas",
  "course.weakSpots": "Lo que sigues fallando",
  "chapter.gone": "Este capítulo ya no existe.",
  "chapter.topics": "Temas",
  "chapter.starting": "Iniciando el análisis…",
  "chapter.analyze": "Analizar material nuevo",
  "chapter.analyzeHint": "La IA propone temas y conceptos del material aún no analizado. Revisas la propuesta antes de que cambie nada.",
  "chapter.noMaterial": "No hay material nuevo que analizar en este capítulo. Sube material primero.",
  "chapter.empty": "Aún no hay temas. Sube material abajo y luego analízalo.",
  "chapter.topicMeta": "{active} de {total} conceptos activos",
  "topic.gone": "Este tema ya no existe.",
  "topic.concepts": "Conceptos",
  "topic.empty": "No hay conceptos en este tema.",
  "topic.needsReview": "Revisar la fuente",
  "topic.conceptMeta": "{state} · dominio {mastery}",
  "unit.item.one": "{n} elemento",
  "unit.item.other": "{n} elementos",
  "unit.answer.one": "{n} respuesta",
  "unit.answer.other": "{n} respuestas",
  "consolidate.continue": "Continuar la consolidación",
  "consolidate.unfinished": "Tu lote de {items} está sin terminar: quedan {left}. Las respuestas ya dadas se conservan.",
  "consolidate.resume": "Reanudar",
  "consolidate.doneTitle": "Consolidado",
  "consolidate.doneBody": "Cada elemento de este concepto ha tenido sus rondas de consolidación. Volverán en tus repasos cuando toque.",
  "consolidate.title": "¿Has estudiado este concepto?",
  "consolidate.body": "Lee primero qué estudiar arriba. Cuando estés listo, cada pregunta se repite hasta que la respondas bien {n} veces (no necesariamente seguidas), con comentarios tras cada respuesta.",
  "consolidate.batch": "Esta tanda: {items} · {answers}",
  "consolidate.more.one": "{n} elemento más espera a una tanda posterior",
  "consolidate.more.other": "{n} elementos más esperan a una tanda posterior",
  "consolidate.button": "He estudiado este concepto",
  "breadcrumb.aria": "Ruta de navegación",
  "dash.title": "Panel",
  "dash.loading": "Cargando tu panel…",
  "dash.aside": "Tu estudio",
  "dash.today": "Hoy",
  "dash.xpTodayPlus": "+{n} XP hoy",
  "dash.goal": "Meta {done}/{target}",
  "dash.tzNote": "Tus días de estudio (racha, meta, XP de hoy) siguen {zone}. Este dispositivo está en {device}.",
  "dash.tzUse": "Usar {zone}",
  "next.title": "Tu siguiente paso",
  "next.resumeTitle": "Continuar la consolidación · Respuesta buena {round} de {total}",
  "next.answersLeft": "{n} respuestas restantes",
  "next.resume": "Reanudar",
  "next.minutes": "unos {n} min",
  "next.startReview": "Empezar el repaso",
  "next.learnTitle": "Sigue aprendiendo: {concept}",
  "next.nextConcept": "siguiente concepto",
  "next.learn": "Aprender",
  "next.setupTitle": "Prepara {concept}",
  "next.theNextConcept": "el siguiente concepto",
  "next.setupDetail": "{course} · actívalo para preparar sus preguntas",
  "next.setup": "Preparar",
  "next.addMaterialTitle": "Añade material a {course}",
  "next.yourCourse": "tu curso",
  "next.addMaterialDetail": "Sube material de estudio o tus propias preguntas y respuestas para construir sus conceptos.",
  "next.firstCourse": "Empieza tu primer curso",
  "next.firstCourseDetail": "Crea un curso y añade material o tus propias preguntas.",
  "next.caughtUp": "Estás al día",
  "next.caughtUpDetail": "Nada pendiente y no hay material nuevo esperando.",
  "streak.title": "Racha diaria",
  "streak.unit.one": "día",
  "streak.unit.other": "días",
  "streak.done": "Hoy completado. Vuelve mañana para seguir.",
  "streak.keep": "Responde una pregunta hoy para mantener tu racha.",
  "streak.start": "Responde una pregunta hoy para empezar una racha.",
  "streak.last7": "Los últimos 7 días",
  "streak.studied": "estudiado",
  "streak.noStudy": "sin estudio",
  "xp.title": "Experiencia",
  "xp.how": "Cómo funcionan los XP",
  "xp.howBody": "Cada respuesta correcta al mismo elemento da más: 10 XP la primera vez, luego 20, 30… hasta 150. Una pista reduce a la mitad los XP de esa respuesta. Las respuestas incorrectas no dan nada, pero no reinician tu progreso. Los XP premian la práctica; nunca cambian tu calendario de repasos.",
  "goal.title": "Meta diaria",
  "goal.sr": "Meta diaria: {done} de {target} respuestas completadas hoy, {percent} por ciento.",
  "goal.answersToday": "{done} / {target} respuestas hoy",
  "goal.perDay": "Respuestas por día",
  "goal.edit": "Editar meta",
  "goal.invalid": "Elige un número entero del 1 al 500.",
  "planner.title": "Planificador",
  "planner.now": "Ahora",
  "planner.1h": "En 1 hora",
  "planner.4h": "En 4 horas",
  "planner.1d": "En 1 día",
  "planner.3d": "En 3 días",
  "planner.7d": "En 7 días",
  "planner.dueNow": "{n} pendientes ahora: unos {min} min",
  "planner.caption": "Repasos pendientes para cada momento, incluidos los atrasados",
  "planner.dueBy": "Vence antes de",
  "planner.items": "Elementos",
  "planner.hint": "Basado en tu calendario de repasos actual; cambia mientras estudias. Cada fila incluye todo lo que vence antes.",
  "activity.title": "Actividad",
  "activity.seeMore": "Ver más",
  "activity.future": "{day}: en el futuro",
  "activity.day": "{day}: {answers}",
  "activity.dayXp": "{day}: {answers}, {xp} XP",
  "activity.aria": "Calendario de actividad: {days}, {answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} día activo",
  "unit.activeDay.other": "{n} días activos",
  "activity.less": "Menos",
  "activity.more": "Más",
  "activity.legendFuture": "Futuro",
  "pb.curriculumHint": "Cuánto del material has estudiado y activado.",
  "pb.conceptsActive": "Conceptos activos",
  "pb.activeOf": "{active} de {total}",
  "pb.memory": "Memoria",
  "pb.memoryHint": "Qué tan bien retienes lo que entrenas. El dominio es una estimación a partir de tus repasos.",
  "pb.mastery": "Dominio (estimación)",
  "pb.itemsTrained": "Elementos en entrenamiento",
  "pb.markedHard": "Marcados como difíciles",
  "pb.dueNow": "Pendientes ahora",
  "pb.laterToday": "Más tarde hoy",
  "pb.tomorrow": "Mañana",
  "pb.next7": "Próximos 7 días",
  "pb.newToLearn": "Nuevos por aprender",
  "pb.overdue.one": "{n} pregunta está atrasada: empieza por esas.",
  "pb.overdue.other": "{n} preguntas están atrasadas: empieza por esas.",
  "pb.caption": "Preguntas que vencen en este curso y cuánto tardan aproximadamente",
  "pb.when": "Cuándo",
  "pb.questions": "Preguntas",
  "pb.time": "Tiempo",
  "pb.minutes": "~{n} min",
  "study.intent.LEARN": "Aprender",
  "study.intent.SCHEDULED_REVIEW": "Repaso",
  "study.intent.PRACTICE": "Práctica",
  "study.intent.EXAM": "Examen",
  "study.intent.CONSOLIDATION": "Consolidación",
  "study.round": "Respuesta buena {n} de {total}",
  "study.progressAria": "Progreso en esta sesión",
  "study.progress": "{n} de {total}",
  "study.xpSessionAria": "{n} XP en esta sesión",
  "study.ownReview": "Repaso libre: tu plan no cambia, sin XP",
  "study.leaveResume": "Salir (reanudar después)",
  "study.end": "Terminar sesión",
  "study.preparing": "Preparando tu sesión…",
  "study.empty.title": "Nada que estudiar ahora",
  "study.empty.body": "Nada cumple los requisitos para esta sesión. Activa un concepto para añadir material nuevo o vuelve cuando haya repasos pendientes.",
  "study.empty.back": "Volver al curso",
  "study.newMaterial": "Material nuevo",
  "study.keyPoints": "Puntos clave",
  "study.sources": "Fuentes",
  "study.ready": "Estoy listo: ponme a prueba",
  "study.answering": "Responder",
  "study.drawHint": "Dibuja tu respuesta abajo. La IA la compara con el dibujo de referencia.",
  "study.note": "Nota (opcional)",
  "study.yourAnswer": "Tu respuesta",
  "study.notePlaceholder": "Algo que añadir a tu dibujo…",
  "study.answerPlaceholder": "Responde con tus propias palabras…",
  "study.stopListening": "Dejar de escuchar",
  "study.speak": "Di tu respuesta",
  "study.evaluating": "Evaluando…",
  "study.submit": "Enviar",
  "study.skip": "Omitir esta pregunta",
  "study.dictationOn": "El dictado lo transcribe tu navegador, que puede enviar el audio a su servicio de voz. Solo se guarda el texto; edítalo antes de enviar.",
  "study.dictationOff": "Las respuestas por voz necesitan Chrome, Edge o Safari. Aquí puedes escribir tu respuesta.",
  "study.drawingCompare": "Tu dibujo y la referencia",
  "study.yourDrawing": "Tu dibujo",
  "study.reference": "Referencia",
  "study.gradedByYou": "Calificado por ti",
  "study.needsGrade": "Necesita tu calificación",
  "study.firstEval": "Primera evaluación",
  "study.secondOpinion": "Segunda opinión",
  "study.afterObjection": "Tras tu objeción: «{text}»",
  "study.referenceSummary": "Respuesta de referencia y fuentes",
  "study.studyConcept": "📖 Estudia este concepto",
  "study.gradeHow": "¿Cuánto lo sabías?",
  "study.gradeYourself": "O califícalo tú",
  "study.yourGrade": "Tu calificación",
  "study.retryEval": "Reintentar la evaluación",
  "study.skipNow": "Omitir por ahora",
  "study.disagree": "¿No estás de acuerdo con la nota?",
  "study.notMemorized": "Aún no memorizado: lo verás de nuevo en esta sesión.",
  "study.levelNext": "Nivel {from} → {to}. Próximo repaso: {when}",
  "study.practiceNote": "La práctica no cambia tu calendario de repasos.",
  "study.complete": "Sesión completada",
  "study.xpSessionPlus": "+{n} XP en esta sesión",
  "study.answeredIn": "{answers} en unos {min} min.",
  "study.wentWell": "{n} salieron bien.",
  "study.steady": "Trabajo constante: esto se va asentando.",
  "study.comeBack": "Las que salieron mal vuelven pronto, y así es como se fijan.",
  "study.stillDue": "Aún pendientes ahora: {n} (unos {min} min).",
  "study.nothingDue": "Nada más está pendiente ahora.",
  "study.done": "Hecho",
  "study.noXp": "Esta respuesta no da XP (práctica, o aún no toca repasar).",
  "study.correctXp": "Respuesta correcta: +{n} XP",
  "study.halfXp": "(pista usada: mitad de XP)",
  "study.hintLabel": "Pista",
  "study.noHint": "No hay pista para esta pregunta.",
  "study.showHint": "Mostrar pista",
  "study.hintHalves": "Usar una pista reduce a la mitad los XP de esta respuesta.",
  "study.revealHint": "Revelar pista",
  "study.plusZero": "+0 XP",
  "study.onlyCorrectSelf": "Solo las respuestas correctas dan XP: tu propio Difícil, Bien o Fácil también cuenta.",
  "study.onlyCorrect": "Solo las respuestas totalmente correctas dan XP. Se conserva tu progreso hacia el siguiente premio.",
  "study.awardCorrect": "Correcta",
  "study.awardHint": "Pista usada",
  "study.ordinal": "respuesta correcta n.º {n} de este elemento",
  "study.ordinalHalf": "respuesta correcta n.º {n} de este elemento, la mitad de {base}",
  "study.batchDone": "Tanda consolidada",
  "study.correctAnswers": "Respuestas correctas",
  "study.xpThisSession": "XP de esta sesión",
  "study.whatNext": "Qué pasa después",
  "study.whatNextBody": "Los elementos cuya última ronda fue correcta vuelven a repaso en unas 4 horas; los demás esperan a la siguiente tanda.",
  "study.waiting.one": "{n} elemento más está esperando",
  "study.waiting.other": "{n} elementos más están esperando",
  "study.batchNotAll": "Esta tanda está hecha, no todo el concepto: {waiting}.",
  "study.allRounds": "Cada elemento de este concepto que esperaba ha recibido tres respuestas buenas.",
  "study.nextBatch": "Siguiente tanda",
  "study.conceptCosts": "Ver el concepto ahora cuenta como usar una pista: esta respuesta da la mitad de XP.",
  "study.openConcept": "Abrir el concepto",
  "study.dontRemember": "📖 ¿No lo recuerdas? Estudia este concepto",
  "study.refDrawing": "El dibujo de referencia",
  "dispute.title": "Pide a la IA que lo revise de nuevo",
  "dispute.testAi": "La IA de prueba no puede leer tu objeción: una segunda opinión repetiría la misma nota. Califícalo tú abajo.",
  "dispute.why": "¿Por qué no estás de acuerdo?",
  "dispute.placeholder": "Di en qué se equivocó la evaluación…",
  "dispute.hint": "La IA ve tu objeción y evalúa de nuevo. Ambas opiniones siguen visibles; tu nota solo cambia si la eliges abajo.",
  "dispute.asking": "Preguntando…",
  "dispute.ask": "Pedir una segunda opinión",
  "eval.correct": "Correcto",
  "eval.complete": "Completo",
  "eval.understanding": "Comprensión",
  "eval.precise": "Preciso",
  "eval.Strong": "Fuerte",
  "eval.Partial": "Parcial",
  "eval.Weak": "Débil",
  "eval.scoreBreakdown": "Desglose de puntuación",
  "eval.right": "Correcto",
  "eval.missing": "Falta",
  "eval.misconception": "Concepto erróneo",
  "eval.materialSays": "El material dice",
  "eval.covered": "Qué cubría tu respuesta",
  "eval.failed": "No se pudo evaluar la respuesta.",
  "eval.aiEvaluation": "Evaluación de la IA: {verdict}",
  "eval.insufficient": "El material del curso no cubre esto lo bastante como para calificarlo.",
  "eval.testAiTitle": "IA de prueba.",
  "eval.testAiBody": "Esta nota viene de un sustituto que solo compara palabras con la referencia: no entiende paráfrasis ni objeciones. Revisa la referencia y califica tú, o conecta una IA real.",
  "conceptPanel.title": "Estudia este concepto",
  "conceptPanel.next": "Ya lo estudié: siguiente pregunta",
  "conceptPanel.closeAria": "Cerrar el concepto",
  "conceptPanel.loading": "Cargando el concepto…",
  "conceptPanel.openFull": "Abrir la página completa del concepto en una pestaña nueva",
  "dictation.blocked": "El micrófono está bloqueado. Permítelo en los ajustes del sitio de tu navegador para dictar.",
  "dictation.network": "El reconocimiento de voz necesita conexión a internet.",
  "dictation.noMic": "No se encontró ningún micrófono.",
  "dictation.stopped": "El reconocimiento de voz se detuvo inesperadamente. Puedes seguir escribiendo.",
  "concept.activate": "Activar",
  "concept.activateHelp": "Prepara las preguntas de este concepto a partir de tu material para que puedas estudiarlo.",
  "concept.markStudied": "Marcar como estudiado",
  "concept.markStudiedHelp": "Lo estudiaste en otro sitio: se anota, sin preparar preguntas todavía.",
  "concept.activateAgainHelp": "Lo estudia de nuevo: sus preguntas vuelven a tus sesiones.",
  "concept.pause": "Pausar",
  "concept.pauseHelp": "Detiene sus preguntas por un tiempo. No se pierde nada.",
  "concept.deactivate": "Desactivar",
  "concept.deactivateHelp": "Lo saca del estudio y los repasos. Tus respuestas e historial se conservan.",
  "concept.resume": "Reanudar",
  "concept.resumeHelp": "Devuelve sus preguntas al estudio y los repasos.",
  "concept.sourceDeleted": "El material del que venía este concepto se eliminó. Consérvalo, edítalo o elimínalo.",
  "concept.manage": "Gestionar este concepto",
  "concept.loadingItems": "Cargando los elementos de estudio…",
  "concept.preparing": "Preparando los elementos de estudio…",
  "concept.itemsFailed": "No se pudieron preparar los elementos de estudio.",
  "concept.noSource": "Este concepto no tiene material de origen con el que crear elementos de estudio.",
  "concept.whatToStudy": "Qué estudiar",
  "concept.reviewOwnHelp": "Hazte preguntas sobre este concepto cuando quieras. No cambia tu plan de repasos ni da XP.",
  "concept.reviewOwn": "🔁 Repasa por tu cuenta",
  "concept.readThen": "Léelos y luego pulsa \"He estudiado este concepto\" abajo para practicarlos.",
  "concept.testMe": "🔁 Ponme a prueba en esto",
  "concept.hideDetails": "Ocultar detalles",
  "concept.details": "Detalles",
  "concept.level": "Nivel {n}",
  "concept.markedHard": "Marcado como difícil",
  "concept.notTraining": "Fuera del entrenamiento",
  "concept.state": "Estado",
  "concept.levelLabel": "Nivel",
  "concept.nextReview": "Próximo repaso",
  "concept.reviews": "Repasos",
  "concept.lapses": "Olvidos",
  "concept.inTraining": "En entrenamiento",
  "concept.questions": "Preguntas",
  "concept.sourcesTitle": "Fuentes",
  "concept.loadingSources": "Cargando las fuentes…",
  "concept.noSources": "No hay pasajes de fuente.",
  "concept.misconceptions": "Conceptos erróneos recurrentes",
  "drawing.answerBy": "Responder dibujando",
  "drawing.studentsDraw": "Los estudiantes responden esta pregunta dibujando. La IA compara su dibujo con este.",
  "drawing.youDraw": "Respondes esta pregunta dibujando. La IA compara tu dibujo con este.",
  "drawing.referenceAlt": "Dibujo de referencia",
  "drawing.explain": "Para preguntas que se responden con un dibujo (una molécula, un esquema, un gráfico): añade el dibujo correcto y los estudiantes dibujarán su respuesta en lugar de escribirla.",
  "drawing.save": "Guardar este dibujo",
  "drawing.replace": "Reemplazar con una imagen…",
  "drawing.upload": "Subir el dibujo…",
  "drawing.drawNew": "Dibujar uno nuevo",
  "drawing.drawHere": "Dibújalo aquí",
  "drawing.words": "Responder con palabras",
  "drawing.tools": "Herramientas de dibujo",
  "drawing.pen": "✏️ Lápiz",
  "drawing.eraser": "🧽 Borrador",
  "drawing.thick": "Línea gruesa",
  "drawing.thin": "Línea fina",
  "drawing.undo": "↶ Deshacer",
  "drawing.clear": "Borrar",
  "drawing.area": "Área de dibujo: dibuja aquí tu respuesta",
  "drawing.photoUpload": "¿Lo dibujaste en papel? Sube una foto",
  "drawing.photoError": "Ese archivo no es una imagen que este navegador pueda leer. Prueba con una foto JPEG o PNG.",
  "drawing.photoAlt": "Tu foto del dibujo",
  "drawing.drawInstead": "Dibujar en su lugar",
  "q.title": "Preguntas",
  "q.introOwn": "Selecciona preguntas para eliminarlas, pausarlas, reanudarlas o moverlas; arrastra ⠿ para reordenarlas; edita una para corregir su título, redacción o respuesta esperada.",
  "q.introManaged": "Este curso viene del Marketplace: su autor mantiene las preguntas al día. Selecciona preguntas para pausarlas o reanudarlas, o dales tu propia prioridad (solo tú la ves).",
  "q.search": "Buscar preguntas",
  "q.searchPlaceholder": "Buscar preguntas y respuestas",
  "q.allPriorities": "Todas las prioridades",
  "q.priorityOnly": "Solo {label} ({n})",
  "q.deselectAll": "Deseleccionar todo",
  "q.selectAll": "Seleccionar todo ({n})",
  "q.selectAllShown": "Seleccionar todo lo mostrado ({n})",
  "q.collapseAll": "Contraer todo",
  "q.expandAll": "Expandir todo",
  "q.selectedAria": "Preguntas seleccionadas",
  "q.selectedCount": "{n} seleccionadas",
  "q.moveTo": "Mover a…",
  "q.setPriority": "Establecer prioridad",
  "q.setPriorityPlaceholder": "Establecer prioridad…",
  "q.reviewSelectedHelp": "Hazte preguntas ahora sobre las seleccionadas. No cambia tu plan de repasos ni da XP.",
  "q.clearSelection": "Borrar selección",
  "q.verb.delete": "Eliminadas",
  "q.verb.pause": "Pausadas",
  "q.verb.resume": "Reanudadas",
  "q.verb.move": "Movidas",
  "q.verb.set_priority": "Actualizadas",
  "unit.question.one": "{n} pregunta",
  "unit.question.other": "{n} preguntas",
  "unit.chapter.one": "{n} capítulo",
  "unit.chapter.other": "{n} capítulos",
  "unit.topic.one": "{n} tema",
  "unit.topic.other": "{n} temas",
  "unit.concept.one": "{n} concepto",
  "unit.concept.other": "{n} conceptos",
  "unit.group.one": "{n} grupo vaciado",
  "unit.group.other": "{n} grupos vaciados",
  "q.newConcepts.one": "{n} concepto nuevo",
  "q.newConcepts.other": "{n} conceptos nuevos",
  "q.removedConcepts.one": "{n} concepto vacío eliminado",
  "q.removedConcepts.other": "{n} conceptos vacíos eliminados",
  "q.noticeBulk": "{verb} {questions}{extra}.",
  "q.noticeDeleted": "Eliminadas {questions}.",
  "q.noticeDeletedGroups": "Eliminadas {questions} y {groups}.",
  "q.confirmDelete": "¿Eliminar {questions}? Sus respuestas e historial de repasos también se eliminan.{also}",
  "q.confirmAlso": " También se eliminan {groups} que se queden sin preguntas.",
  "q.emptySearch": "Ninguna pregunta coincide con esta búsqueda.",
  "q.empty": "Aún no hay preguntas. Activa un concepto o importa tus propias preguntas y respuestas.",
  "q.clearToReorder": "Borra la búsqueda para reordenar estas preguntas.",
  "q.select": "Seleccionar: {text}",
  "q.otherWordings.one": "+{n} otra redacción",
  "q.otherWordings.other": "+{n} otras redacciones",
  "q.editAria": "Editar pregunta",
  "q.titleLabel": "Título (se muestra en las listas)",
  "q.wordings": "Redacciones de la pregunta",
  "q.wording": "Redacción {n}",
  "q.addWording": "+ Añadir otra redacción",
  "q.expected": "Respuesta esperada",
  "q.prio1": "Esencial: lo central, hay que saberlo",
  "q.prio2": "Importante: conviene saberlo",
  "q.prio3": "Extra: apéndice, más detalle",
  "q.keyPoints": "Puntos clave (uno por línea, hasta 10)",
  "q.moveAria": "Mover preguntas",
  "q.moveHeading": "Mover {questions} a",
  "q.choose": "Elige un tema o un concepto…",
  "q.topicOption": "Tema: {title} (cada pregunta conserva su concepto)",
  "q.conceptOption": "   ↳ en el concepto: {title}",
  "q.removeEmpty": "Quitar los conceptos que se queden sin preguntas",
  "q.moveHint": "Las preguntas conservan su progreso de repaso. En un concepto no activo, no se repasan hasta que lo esté.",
  "q.move": "Mover",
  "q.groupSelect": "Seleccionar todas las preguntas de {label}",
  "mat.chapterTitle": "Material del capítulo",
  "mat.collapseLabel": "material de estudio",
  "mat.files.one": "{n} archivo",
  "mat.files.other": "{n} archivos",
  "mat.uploading": "Subiendo…",
  "mat.upload": "Subir material",
  "mat.uploadQa": "Subir preguntas y respuestas",
  "mat.paste": "Pegar texto",
  "mat.howTo": "Cómo preparar preguntas y respuestas",
  "mat.howToBody": "Sube un archivo PDF, Word, de texto o Markdown en el que cada pregunta empiece con “Domanda:” y su respuesta esperada con “Risposta:” (o “Question:” / “Answer:”), al principio de una línea. Los encabezados agrupan las preguntas en temas.",
  "mat.howToBody2": "Cada pregunta se convierte en un concepto marcado como sin estudiar, con tu respuesta como respuesta esperada. Actívalo para empezar a repasar. La importación no usa IA.",
  "mat.loading": "Cargando el material…",
  "mat.none": "Aún no hay material. Sube archivos PDF, Word, PowerPoint, de texto o Markdown.",
  "mat.file": "Archivo",
  "mat.status": "Estado",
  "mat.passages": "Pasajes",
  "mat.added": "Añadido",
  "mat.actions": "Acciones",
  "mat.qa": "P&R",
  "mat.processing": "Procesando…",
  "mat.ready": "Listo",
  "mat.failed": "Fallido",
  "mat.download": "Descargar",
  "mat.confirmDelete": "¿Eliminar {name}? Los conceptos creados a partir de él se marcarán para revisión.",
  "mat.pasteAria": "Pegar texto",
  "mat.pastePlaceholder": "p. ej., apuntes de la clase 3",
  "mat.thisTextIs": "Este texto es",
  "mat.asMaterial": "Material de estudio",
  "mat.asQa": "Preguntas y respuestas (Domanda: / Risposta:)",
  "mat.text": "Texto",
  "mat.textPlaceholderQa": "# Tema\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# Encabezado\nTus apuntes…",
  "mat.adding": "Añadiendo…",
  "mat.addText": "Añadir texto",
  "mat.pastedName": "Texto pegado {when}",
  "prop.title": "Plan de estudios propuesto",
  "prop.reading": "La IA está leyendo tu material…",
  "prop.applied": "Esta propuesta ya se aplicó.",
  "prop.failed": "La IA no pudo proponer un plan de estudios.",
  "prop.blank": "Cada capítulo, tema y concepto necesita un título.",
  "prop.longMaterial": "El material era largo: esto cubre sus primeros {used} de {total} pasajes.",
  "prop.dropped": "Se omitieron {n} conceptos propuestos porque no se pudieron vincular a tu material.",
  "prop.hint": "Edita lo que quieras abajo: renombra, reordena, mueve conceptos entre temas, combina, elimina o añade. No se activa nada: tú eliges qué estudiar después.",
  "prop.chapterTitle": "Título del capítulo",
  "prop.deleteChapter": "Eliminar capítulo",
  "prop.accept": "Aceptar el plan de estudios",
  "prop.reject": "Rechazar la propuesta",
  "prop.topicAria": "Tema {title}",
  "prop.existingTopic": "tema existente",
  "prop.topicTitle": "Título del tema",
  "prop.moveTopicUp": "Subir el tema",
  "prop.moveTopicDown": "Bajar el tema",
  "prop.deleteTopic": "Eliminar tema",
  "prop.conceptTitle": "Título del concepto",
  "prop.exists": "ya existe",
  "prop.moveConceptUp": "Subir el concepto",
  "prop.moveConceptDown": "Bajar el concepto",
  "prop.moveToTopic": "Mover al tema",
  "prop.untitled": "Tema sin título",
  "prop.merge": "Combinar con el siguiente",
  "prop.addConcept": "+ Añadir concepto",
  "mkt.intro": "Cursos creados por otros usuarios de LEARNABLE. Añade uno a tus cursos y estúdialo con tu propio calendario: su autor lo mantiene al día. Para compartir uno tuyo, ábrelo y rellena su “Página del marketplace”.",
  "mkt.categories": "Categorías",
  "mkt.all": "Todas",
  "mkt.searchPlaceholder": "Buscar por título o descripción",
  "mkt.level": "Nivel",
  "mkt.language": "Idioma",
  "mkt.size": "Tamaño",
  "mkt.sort": "Ordenar",
  "mkt.any": "Cualquiera",
  "mkt.loading": "Cargando cursos…",
  "mkt.noMatch": "Ningún curso coincide aún con estos filtros.",
  "mkt.publishedByMe": "Publicados por mí",
  "mkt.status.DRAFT": "Borrador",
  "mkt.status.PUBLISHED": "Publicado",
  "mkt.status.UNPUBLISHED": "No publicado",
  "mkt.version": "versión {n}",
  "mkt.students.one": "{n} estudiante",
  "mkt.students.other": "{n} estudiantes",
  "mkt.editCourse": "Editar el curso y su página",
  "mkt.by": "de {author}",
  "mkt.inYourCourses": "En tus cursos",
  "mkt.loadingCourse": "Cargando el curso…",
  "mkt.updated": "actualizado el {date}",
  "mkt.statStudents": "Estudiantes",
  "mkt.yourCourse": "Tu curso",
  "mkt.draftTag": "borrador",
  "mkt.notPublishedTag": "no publicado",
  "mkt.open": "Abrir en mis cursos",
  "mkt.addBack": "Volver a añadir a mis cursos",
  "mkt.add": "Añadir a mis cursos · {price}",
  "mkt.about": "Acerca de este curso",
  "mkt.learn": "Qué aprenderás",
  "mkt.audience": "Para quién es",
  "mkt.hiddenNote": "Las preguntas y respuestas se ven cuando el curso está en tus cursos. Las estudias dentro de LEARNABLE: el material del autor no se puede descargar.",
  "sales.originTitle": "🛒 Del marketplace",
  "sales.madeBy": "Creado por {author} (versión {version}). Su autor mantiene al día los capítulos, preguntas y respuestas, así que no puedes editarlos aquí: las actualizaciones te llegan automáticamente.",
  "sales.yourStudy": "Tu estudio es tuyo: activar conceptos, pausar, tus respuestas, tu plan de repasos y los XP, y la prioridad que das a cada pregunta (solo tú la ves).",
  "sales.seePage": "Ver su página del marketplace",
  "sales.title": "🛒 Página del marketplace",
  "sales.pPublished": "Publicado · versión {n}",
  "sales.pNot": "No publicado",
  "sales.pDraft": "Borrador",
  "sales.pNone": "No compartido",
  "sales.explain": "Comparte este curso con otros usuarios. Aquí escribes su página, lo único que la gente ve antes de añadirlo: de qué trata, para quién es, qué aprenderán. También ven los títulos de los capítulos y cuántas preguntas hay; las preguntas en sí solo cuando lo tienen, y tu material subido nunca.",
  "sales.seeAsOthers": "Verlo como lo ven los demás",
  "sales.edit": "Editar la página del marketplace",
  "sales.write": "Escribir una página del marketplace",
  "sales.subtitle": "Subtítulo",
  "sales.subtitleHint": "(una línea, p. ej., “Las 300 preguntas del oral, con respuestas modelo”)",
  "sales.category": "Categoría",
  "sales.description": "Descripción",
  "sales.descriptionHint": "(de qué trata, cómo lo hiciste, cómo usarlo)",
  "sales.outcomes": "Qué aprenderán los estudiantes",
  "sales.outcomesHint": "(uno por línea, hasta 8)",
  "sales.tags": "Etiquetas",
  "sales.tagsHint": "(separadas por comas, hasta 8)",
  "sales.saveDraft": "Guardar borrador",
  "sales.savePage": "Guardar página",
  "sales.publish": "Publicar",
  "sales.publishUpdate": "Publicar una actualización",
  "sales.publishHintUpdate": "Envía tus capítulos, preguntas y respuestas actuales a todos los que tienen el curso. Su progreso se conserva.",
  "sales.publishHint": "Hace visible el curso en el Marketplace. Por ahora es gratis. Puedes seguir editándolo y publicar actualizaciones después.",
  "sales.rights": "Las preguntas y respuestas son mías para compartir (las escribí yo, o tengo los derechos del material del que provienen).",
  "sales.publishing": "Publicando…",
  "sales.publishUpdateBtn": "Publicar actualización",
  "sales.unpublish": "Despublicar",
  "sales.noteSaved": "Guardado: la página del marketplace lo muestra ya.",
  "sales.noteDraft": "Borrador guardado. Nadie más lo ve hasta que publiques.",
  "sales.notePublishedV": "Versión {n} publicada: todos los que tienen el curso reciben ahora tus últimas preguntas.",
  "sales.notePublished": "¡Publicado! Otros usuarios ya pueden encontrarlo en el Marketplace.",
  "sales.noteUnpublished": "Despublicado: las personas nuevas no pueden encontrarlo. Quienes ya lo tienen lo conservan.",
  "prog.empty": "Crea un curso y empieza a aprender para ver tu progreso.",
  "prog.weakConcepts": "Conceptos débiles",
  "prog.weakMeta": "olvidos: {lapses} · marcados difíciles: {hard}",
  "prog.byChapter": "Por capítulo y tema",
  "prog.colChapter": "Capítulo / tema",
  "weak.intro": "Errores encontrados en tus respuestas recientes, por concepto. Desaparecen cuando tus últimas respuestas al elemento ya no los muestran. La práctica no cambia tu calendario de repasos.",
  "weak.loading": "Revisando tus respuestas recientes…",
  "weak.empty": "No hay errores recurrentes ahora. Sigue respondiendo y aparecerán aquí.",
  "weak.practiceTop.one": "Practica el concepto principal ({n})",
  "weak.practiceTop.other": "Practica los {n} primeros conceptos",
  "weak.practiceThis": "Practica esto",
  "weak.seen.one": "visto {n} vez, la última el {date}",
  "weak.seen.other": "visto {n} veces, la última el {date}",
  "home.intro": "Los repasos programados conservan lo que has aprendido. Los recuentos pendientes siguen las mismas reglas que una sesión de repaso.",
  "home.noCourses": "Aún no hay cursos.",
  "home.createOnDashboard": "Crea uno en tu panel",
  "home.meta": "{due} pendientes ahora · {introduced} de {trained} elementos presentados",
  "activity.pageIntro": "Respuestas completadas por día durante el último año, en tu zona horaria. Una respuesta cuenta cuando tiene una calificación final, sea correcta o no.",
  "reset.title": "Restablece tu contraseña",
  "reset.intro": "Introduce el correo de tu cuenta. Te enviaremos un enlace para elegir una nueva contraseña; funciona una vez, durante 30 minutos.",
  "reset.send": "Enviar enlace de restablecimiento",
  "reset.sentMessage": "Si existe una cuenta con este correo, va en camino un enlace para restablecer su contraseña. Revisa tu bandeja de entrada (y el spam).",
  "reset.back": "Volver a iniciar sesión",
  "reset.chooseTitle": "Elige una nueva contraseña",
  "reset.incomplete": "Este enlace está incompleto. Abre de nuevo el enlace del correo o pide uno nuevo.",
  "reset.done": "Tu contraseña se ha cambiado. Se cerró la sesión en todos los dispositivos: inicia sesión con la nueva contraseña.",
  "reset.newPassword": "Nueva contraseña",
  "reset.repeat": "Repite la nueva contraseña",
  "reset.tooShort": "Usa al menos {n} caracteres.",
  "reset.mismatch": "Las dos contraseñas no coinciden.",
  "reset.set": "Establecer nueva contraseña",
  "source.aria": "Pasaje de la fuente",
  "source.closeAria": "Cerrar la fuente",
  "source.loading": "Cargando el pasaje…",
  "source.open": "Abrir el pasaje de la fuente",
  "course.loadingCurriculum": "Cargando el plan de estudios…",
  "mkt.addPlain": "Añadir a mis cursos",
  "sales.pageName": "Página del marketplace",
};
